export const DEFAULT_ERROR_MESSAGE
  = 'The Server Encountered an Error. Please try again later';
